import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { forYou, notForYou } from '../data/content';
export function FitSection() {
  return <section className="bg-night" data-id="element-64" data-mp="1an1pc35a7nsq">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-20" style={{
      paddingTop: "0px"
    }} data-id="element-65" data-mp="1p9uu4eh6db6o">
        <h2 className="text-center font-display text-[1.75rem] font-semibold tracking-tight text-parchment sm:text-4xl" style={{
        fontSize: "36px"
      }} data-id="element-66" data-mp="1kjo7ula4y2rl">
          ¿Es para vos?
        </h2>

        <div className="mx-auto mt-10 grid max-w-4xl gap-4 md:grid-cols-2" data-id="element-67" data-mp="1tbyjm70oigay">
          <div className="rounded-2xl border border-gold-soft/40 bg-night-panel p-6 sm:p-7" data-id="element-68" data-mp="1tdsxj1dj985j">
            <h3 className="font-sans text-sm font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-69" data-mp="286wbyzvtv5s1">
              Sí, es para vos si…
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-70" data-mp="dvzfd6u6n4fz">
              {forYou.map(item => <li key={item} className="flex gap-3" data-id="element-71" data-mp="8vuz9hx6sbqa">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-gold-soft" aria-hidden="true" data-id="element-72" data-mp="8xfrh0w13ikz" />
                  <span className="font-sans text-[0.95rem] text-parchment/85" data-id="element-73" data-mp="2jttrett28z9g">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-night-line bg-night-panel/60 p-6 sm:p-7" data-id="element-74" data-mp="2ss5dciizf8vk">
            <h3 className="font-sans text-sm font-semibold uppercase tracking-[0.14em] text-rust-soft" data-id="element-75" data-mp="2xkp0o77h1idk">
              No es para vos si…
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-76" data-mp="37htglpaq4hlx">
              {notForYou.map(item => <li key={item} className="flex gap-3" data-id="element-77" data-mp="37g07m3cn1lar">
                  <XIcon className="mt-0.5 h-5 w-5 flex-none text-rust-soft" aria-hidden="true" data-id="element-78" data-mp="3biws5zlqnrhc" />
                  <span className="font-sans text-[0.95rem] text-parchment/60" data-id="element-79" data-mp="3gj1ck0prp6cu">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}